import { render, staticRenderFns } from "./authStep.vue?vue&type=template&id=ccf3524a&scoped=true"
import script from "./authStep.vue?vue&type=script&lang=js"
export * from "./authStep.vue?vue&type=script&lang=js"
import style0 from "./authStep.vue?vue&type=style&index=0&id=ccf3524a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf3524a",
  null
  
)

export default component.exports